function parseTree(array, parent, tree) {
    tree = tree || []
    let parentid = parent ? parent._id : null
    var children = array.filter(child => child.parent == parentid);

    if (children.length) {
        if (parentid) {
            parent.children = children;
        } else {
            tree = children
        }
        children.forEach(child => {
            child.children = [];
            parseTree(array, child, tree)
        })
    }
    return tree;
}
module.exports =parseTree